import { API_BASE_URL } from '../config';
import { clearAllProfessionalDualModeChoices } from '../utils/professionalDualModeStorage';

export async function logout() {
  try {
    await fetch(`${API_BASE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
  } catch (e) {
    console.error('Logout request failed', e);
  }
  // Clear only auth and session-specific keys, preserve UI preferences like darkMode
  localStorage.removeItem('authToken');
  localStorage.removeItem('admin_token');
  clearAllProfessionalDualModeChoices();

  sessionStorage.clear();
  // Redirect to homepage
  window.location.href = '/';
}
